import { Button } from '@/components/ui/button'

export default function SettingsPage() {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6">Settings</h1>
      <p className="text-gray-500">API keys, preferences, LLM configuration - coming soon</p>
    </div>
  )
}
